import { render, staticRenderFns } from "./SpModalForm.vue?vue&type=template&id=5b8304f7&"
import script from "./SpModalForm.vue?vue&type=script&lang=js&"
export * from "./SpModalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports